import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import { ASSETS_URL } from "@/config/deployConstants";
import { useClassManagementContextSelector } from "@/features/UserContentManagement/ClassPage/hooks/useClassManagementContext";
import { iconSizes } from "@/utils/iconProps";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { PlusIcon } from "lucide-react";
import Image from "next/image";

const AddStudentToClassSectionState = () => {
    const openInviteToClassPopup = useClassManagementContextSelector(state => state.openInviteToClassPopup);

    return (
        <FlexColumnAlignJustifyCenter
            style={{
                gap: spacing.MD_S,
                padding: spacing.LG_3,
                paddingTop: "10rem",
                marginTop: "auto",
            }}>
            <Image
                src={`${ASSETS_URL}/images/dude-in-green-bg.svg`}
                alt="Add student to class section state"
                width={140}
                height={140}
            />
            <FlexColumnAlignJustifyCenter>
                <span className="bodyBold2">Add students</span>
                <span className="secondaryText2">No students in this sections. Invite them to track progress!</span>
            </FlexColumnAlignJustifyCenter>
            <CircularRectTextButton
                className="secondaryTextBold1"
                onClick={openInviteToClassPopup}
                style={{
                    backgroundColor: themeColors.neutralBlack,
                    color: themeColors.neutralWhite,
                    padding: `${spacing.XS} ${spacing.SM}`,
                    gap: spacing.XS,
                }}>
                <PlusIcon size={iconSizes.MD_S} strokeWidth={2.5} />
                <span>Invite students to section</span>
            </CircularRectTextButton>
        </FlexColumnAlignJustifyCenter>
    );
};

export default AddStudentToClassSectionState;
